<template>
  <div>
    <div class="container" style="padding: 60px 0px">
      <b-col cols="12">
        <b-link to="/" class="brand-logo"
          ><img
            src="data:image/png;base64,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"
            alt="logo"
            class=""
            style="max-width: 150px"
          /> </b-link
      ></b-col>
      <b-card class="schedule mt-5">
        <div class="schedule_cards">
          <div class="schedule_cards-title">
            <validation-observer ref="simpleRules">
              <b-row>
                <b-col xs="12" :sm="services.length > 0 ? '6' : '12'">
                  <validation-provider
                    name="schedule"
                    #default="{ errors }"
                    rules="required"
                  >
                    <b-form-group>
                      <Select2
                        :placeholder="$t('selectSchedule')"
                        :class="errors.length > 0 ? 'is-invalid' : null"
                        v-model="schedule_selected"
                        :options="schedules"
                      />
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col xs="12" sm="6" v-if="services.length > 0 ? true : false">
                  <validation-provider
                    name="services"
                    #default="{ errors }"
                    rules="required"
                  >
                    <b-form-group :class="{ 'has-error': errors.length > 0 }">
                      <Select2
                        placeholder="Please select type of services"
                        v-model="services_selected"
                        :options="services"
                      />
                    </b-form-group>
                  </validation-provider>
                </b-col>
              </b-row>
              <b-row> </b-row>
              <b-row>
                <b-col xs="12" sm="6">
                  <!-- password -->
                  <b-form-group>
                    <label> {{ $t("originStation") }} </label>
                    <Select4
                      v-model="columnFilters.pol_code"
                      placeholder="POL"
                      @select="({ name }) => (columnFilters.pol = name)"
                      :options="{
                        value: 'code',
                        label: 'name',
                        data: ports,
                        fields: [
                          { field: 'code', label: 'Code' },
                          { field: 'name', label: 'Name' },
                          { field: 'type', label: 'Service' },
                          {
                            field: 'country_code',
                            label: 'Country Code',
                          },
                        ],
                      }"
                    />
                  </b-form-group>
                </b-col>
                <b-col xs="12" sm="6">
                  <!-- password -->
                  <b-form-group>
                    <label>{{ $t("destinationStation") }}</label>
                    <Select4
                      v-model="columnFilters.pod_code"
                      @select="({ name }) => (columnFilters.pod = name)"
                      placeholder="POD"
                      :options="{
                        value: 'code',
                        label: 'name',
                        data: ports,
                        fields: [
                          { field: 'code', label: 'Code' },
                          { field: 'name', label: 'Name' },
                          { field: 'type', label: 'Service' },
                          {
                            field: 'country_code',
                            label: 'Country Code',
                          },
                        ],
                      }"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col xs="12" sm="6">
                  <validation-provider #default="{ errors }" rules="">
                    <b-form-group>
                      <label> {{ $t("fromDate") }}</label>
                      <date-picker
                        ref="datePicker"
                        v-model="columnFilters.from_date"
                        type="date"
                        class="w-full"
                        value-type="format"
                        title-format="DD/MM/YY"
                        :class="errors.length > 0 ? 'is-invalid' : null"
                        time-title-format="DD/MM/YY"
                        placeholder="Select date"
                        :show-time-panel="showTimePanel"
                        format="DD/MM/YY"
                        @close="handleOpenChange"
                      >
                      </date-picker>
                    </b-form-group>
                  </validation-provider>
                </b-col>

                <b-col xs="12" sm="6">
                  <validation-provider #default="{ errors }" rules="">
                    <b-form-group>
                      <label> {{ $t("toDate") }}</label>
                      <date-picker
                        ref="datePicker"
                        v-model="columnFilters.to_date"
                        type="date"
                        class="w-full"
                        value-type="format"
                        :class="errors.length > 0 ? 'is-invalid' : null"
                        title-format="DD/MM/YY"
                        time-title-format="DD/MM/YY"
                        placeholder="Select date"
                        :show-time-panel="showTimePanel"
                        format="DD/MM/YY"
                        @close="handleOpenChange"
                      >
                      </date-picker>
                    </b-form-group>
                  </validation-provider>
                </b-col>
              </b-row>
            </validation-observer>

            <b-row class="px-3 pb-3">
              <b-col cols="12" class="text-center">
                <button
                  type="button"
                  class="btn btn-success"
                  @click="getSchedule"
                >
                  <feather-icon icon="SearchIcon" class="cursor-pointer" />
                  {{ $t("search") }}
                </button>
              </b-col>
            </b-row>
            <b-row class="pt-2">
              <b-col cols="12">
                <vue-good-table
                  v-if="fields.length > 0"
                  :columns="fields"
                  :rows="schedule_list"
                  :line-numbers="true"
                >
                  <template slot="table-row" slot-scope="props">
                    <!-- Column: Action -->
                    <span v-if="props.column.field === 'action'">
                      <b-button
                        variant="primary"
                        size="sm"
                        @click="onUserBooking(props.row)"
                      >
                        Booking
                      </b-button>
                      <!-- <b-button
                      variant="primary"
                      size="sm"
                      v-if="getWr1() && props.row.service_type_id == 3"
                      class="btn"
                      v-b-tooltip.hover.top="'Booking'"
                      @click="onHandlerBooking(props)"
                    >
                      <feather-icon icon="CheckIcon" />
                    </b-button> -->
                    </span>
                    <span v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </span>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-card>
      <ScheduleListBooking
        v-model="valueModal"
        :key="valueModal"
        :currentItem="currentItem"
      />

      <b-modal
        id="modal-regiter"
        :title="$t('REGISTRATION')"
        size="md"
        hide-footer
      >
        <b-card-text>
          <div class="px-2 auth">
            <div class="auth-left">
              <validation-observer ref="registerForm" #default="{ invalid }">
                <b-form class="auth-login-form mt-2" @submit.prevent="login">
                  <!-- email -->
                  <b-form-group>
                    <validation-provider
                      #default="{ errors }"
                      name="Company name"
                      rules="required"
                    >
                      <label class="pl-1">
                        {{ $t("companyName") }}<span class="required">*</span>
                      </label>

                      <b-form-input
                        v-model="user.companyName"
                        class="round"
                        :state="errors.length > 0 ? false : null"
                        :placeholder="$t('enterCompanyName')"
                      />
                      <small v-show="errors.length > 0" class="text-danger">{{
                        errors[0]
                      }}</small>
                    </validation-provider>
                  </b-form-group>
                  <!-- email -->
                  <b-form-group>
                    <validation-provider
                      #default="{ errors }"
                      name="Tax Code"
                      rules="required"
                    >
                      <label class="pl-1">
                        {{ $t("taxCode")
                        }}<span class="required">*</span></label
                      >
                      <b-form-input
                        v-model="user.taxCode"
                        class="round"
                        :state="errors.length > 0 ? false : null"
                        :placeholder="$t('enterTaxCode')"
                      />
                      <small v-show="errors.length > 0" class="text-danger">{{
                        errors[0]
                      }}</small>
                    </validation-provider>
                  </b-form-group>
                  <b-form-group>
                    <validation-provider
                      #default="{ errors }"
                      name="Address"
                      rules="required"
                    >
                      <label class="pl-1">
                        {{ $t("address")
                        }}<span class="required">*</span></label
                      >
                      <b-form-input
                        v-model="user.companyAddress"
                        class="round"
                        :state="errors.length > 0 ? false : null"
                        :placeholder="$t('enterAddress')"
                      />
                      <small v-show="errors.length > 0" class="text-danger">{{
                        errors[0]
                      }}</small>
                    </validation-provider>
                  </b-form-group>
                  <!-- email -->
                  <b-form-group>
                    <validation-provider
                      #default="{ errors }"
                      name="Contact name"
                      rules="required"
                    >
                      <label class="pl-1"
                        >{{ $t("contactName")
                        }}<span class="required">*</span></label
                      >
                      <b-form-input
                        v-model="user.fullName"
                        class="round"
                        :state="errors.length > 0 ? false : null"
                        :placeholder="$t('placeholderName')"
                      />
                      <small v-show="errors.length > 0" class="text-danger">{{
                        errors[0]
                      }}</small>
                    </validation-provider>
                  </b-form-group>
                  <!-- email -->

                  <label class="pl-1">
                    {{ $t("gender") }}<span class="required">*</span></label
                  >
                  <b-form-group class="pl-1 pt-1">
                    <b-row>
                      <b-col cols="4">
                        <b-form-radio
                          v-model="user.genderId"
                          name="some-radios"
                          value="1"
                        >
                          {{ $t("Male") }}
                        </b-form-radio>
                      </b-col>
                      <b-col cols="4">
                        <b-form-radio
                          v-model="user.genderId"
                          name="some-radios"
                          value="2"
                        >
                          {{ $t("Female") }}
                        </b-form-radio>
                      </b-col>
                    </b-row>
                  </b-form-group>
                  <!-- email -->
                  <b-form-group>
                    <validation-provider
                      #default="{ errors }"
                      name="Phone"
                      rules="required|regex:^([0-9]+)$"
                    >
                      <label class="pl-1">
                        {{ $t("phone") }}<span class="required">*</span> (Only
                        Phone)</label
                      >
                      <b-form-input
                        v-model="user.phone"
                        class="round"
                        :state="errors.length > 0 ? false : null"
                        :placeholder="$t('placeholderPhone')"
                      />
                      <small v-show="errors.length > 0" class="text-danger">{{
                        errors[0]
                      }}</small>
                    </validation-provider>
                  </b-form-group>
                  <!-- email -->
                  <b-form-group>
                    <validation-provider
                      #default="{ errors }"
                      name="Email"
                      rules="required|email"
                    >
                      <label class="pl-1">
                        {{ $t("email") }}<span class="required">*</span> (eg.:
                        joe@xyz.com)</label
                      >
                      <b-form-input
                        v-model="user.email"
                        class="round"
                        :state="errors.length > 0 ? false : null"
                        :placeholder="$t('enterEmail')"
                      />
                      <small v-show="errors.length > 0" class="text-danger">{{
                        errors[0]
                      }}</small>
                    </validation-provider>
                  </b-form-group>
                  <!-- email -->

                  <!-- checkbox -->
                  <b-form-group>
                    <span class="text-danger">{{ errMsg }}</span>
                  </b-form-group>

                  <!-- submit button -->
                  <b-form-group class="text-center">
                    <a
                      class="font-weight-bolder h3 text-success"
                      @click="register"
                      :disabled="invalid"
                      >{{ $t("register") }}</a
                    >
                  </b-form-group>
                </b-form>
              </validation-observer>
            </div>
          </div>
        </b-card-text>
      </b-modal>
    </div>
  </div>
</template>
  
  <script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import Select2 from "v-select2-component";
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BModal,
  BFormCheckbox,
  BFormGroup,
  VBTooltip,
  BFormSelect,
  BFormDatepicker,
  BFormRadioGroup,
  BFormInvalidFeedback,
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import { VueGoodTable } from "vue-good-table";
import "@core/scss/vue/libs/vue-good-table.scss";
import { mapState, mapActions } from "vuex";
import RequestQuotation from "@/views/wr1/quotation/RequestQuotation.vue";
import ScheduleListBooking from "@/views/wr1/schedule-list/ScheduleListBooking.vue";
import moment from "moment";
export default {
  components: {
    RequestQuotation,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    Select2,
    VueGoodTable,
    BFormSelect,
    BFormDatepicker,
    BFormRadioGroup,
    BFormInvalidFeedback,
    ScheduleListBooking,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data() {
    return {
      user: { genderId: 1 },
      bankItems: [],
      // validation rules

      errMsg: "",
      valueModal: false,
      showTimePanel: false,
      currentItem: {},
      columnFilters: {
        to_date: "",
        from_date: "",
        status: "",
        schedule: "",
        service: "",
        pol: "",
        pod: "",

      },
      userData: JSON.parse(localStorage.getItem("userData")),
      schedule_selected: "SEA",
      services_selected: "LCL",
      modalShow: false,
      schedules: [
        { id: "SEA", text: "Sea" },
        { id: "AIR", text: "Air" },
        { id: "DOMESTIC", text: "Domestic" },
      ],
      services: [
        { id: "LCL", text: "LCL SCHEDULE" },
        { id: "FCL", text: "FCL SCHEDULE" },
      ],
      pol: "",
      pod: "",
      selected_radios: "",
      options_radios: [
        { text: "Choose from list Approved Quotation", value: 0 },
        { text: "New Quotation", value: 1 },
      ],
      polList: [],
      podList: [],

      services_options: {
        SEA: [
          { id: "LCL", text: "LCL SCHEDULE" },
          { id: "FCL", text: "FCL SCHEDULE" },
        ],
        DOMESTIC: [
          { id: "FTL", text: "FTL SCHEDULE" },
          { id: "LTL", text: "LTL SCHEDULE" },
        ],
        AIR: [],
      },
      constantsType: {
        LCL: "LCL",
        FCL: "FCL",
        FTL: "Container Trucking",
        LTL: "Van Trucking",
        AIR: "AIR",
      },
      schedule_list: [],
      request_quotation: {},
      fields: [],
      fields_all: {
        AIR: [
          {
            label: "POL",
            thClass: "text-uppercase align-middle",
            field: "pol",
            tdClass: "align-middle text-center",

            filterOptions: {
              enabled: false,
              placeholder: "POL",
            },
          },
          {
            label: "POD",
            field: "pod",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "POD",
            },
          },
          {
            label: "LINE",
            thClass: "text-uppercase align-middle",
            field: "carrier",
            tdClass: "align-middle text-center",

            filterOptions: {
              enabled: false,
              placeholder: "CARRIER",
            },
          },
          {
            label: "ETD",
            tdClass: "align-middle text-center",

            thClass: "text-uppercase align-middle",
            field: "etd",
            filterOptions: {
              enabled: false,
              placeholder: "ETD",
            },
          },
          {
            label: "ETA",
            tdClass: "align-middle text-center",

            thClass: "text-uppercase align-middle",
            field: "eta",
            filterOptions: {
              enabled: false,
              placeholder: "ETD",
            },
          },
          {
            label: "TRANSIT TIME",
            tdClass: "align-middle text-center",

            field: "transit_time",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "TRANSIT TIME",
            },
          },
          {
            label: "CARGO CUT OFF",
            tdClass: "align-middle text-center",

            field: "cargo_cut_off",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "CARGO CUT OFF",
            },
          },
          {
            label: "DOC CUT OFF",
            tdClass: "align-middle ",

            field: "doc_cut_off",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "DOC CUT OFF",
            },
          },
          {
            label: "TRANSIT PORT",
            tdClass: "align-middle text-center",

            field: "transit",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "TRANSIT PORT",
            },
          },
          {
            thClass: "text-uppercase align-middle",
            label: "Action",
            tdClass: "align-middle text-center",

            field: "action",
          },
        ],
        LCL: [
          {
            label: "POL",
            thClass: "text-uppercase align-middle",
            field: "pol",
            tdClass: "align-middle text-center",

            filterOptions: {
              enabled: false,
              placeholder: "POL",
            },
          },
          {
            label: "POD",
            field: "pod",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "POD",
            },
          },
          {
            label: "LINE",
            thClass: "text-uppercase align-middle",
            field: "carrier",
            tdClass: "align-middle text-center",

            filterOptions: {
              enabled: false,
              placeholder: "CARRIER",
            },
          },
          {
            label: "ETD",
            tdClass: "align-middle text-center",

            thClass: "text-uppercase align-middle",
            field: "etd",
            filterOptions: {
              enabled: false,
              placeholder: "ETD",
            },
          },
          {
            label: "ETA",
            tdClass: "align-middle text-center",

            thClass: "text-uppercase align-middle",
            field: "eta",
            filterOptions: {
              enabled: false,
              placeholder: "ETA",
            },
          },
          {
            label: "TRANSIT TIME",
            tdClass: "align-middle text-center",

            field: "transit_time",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "TRANSIT TIME",
            },
          },

          {
            label: "CARGO CUT OFF",
            tdClass: "align-middle text-center",

            field: "cargo_cut_off",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "CARGO CUT OFF",
            },
          },
          {
            label: "DOC CUT OFF",
            tdClass: "align-middle text-center",

            field: "doc_cut_off",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "DOC CUT OFF",
            },
          },
          {
            label: "TRANSIT PORT",
            tdClass: "align-middle text-center",

            field: "transit",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "TRANSIT PORT",
            },
          },

          {
            thClass: "text-uppercase align-middle",
            label: "Action",
            tdClass: "align-middle text-center",

            field: "action",
          },
        ],
        FCL: [
          {
            label: "POL",
            thClass: "text-uppercase align-middle",
            field: "pol",
            tdClass: "align-middle text-center",

            filterOptions: {
              enabled: false,
              placeholder: "POL",
            },
          },
          {
            label: "POD",
            field: "pod",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "POD",
            },
          },
          {
            label: "LINE",
            thClass: "text-uppercase align-middle",
            field: "carrier",
            tdClass: "align-middle text-center",

            filterOptions: {
              enabled: false,
              placeholder: "CARRIER",
            },
          },
          {
            label: "ETD",
            tdClass: "align-middle text-center",

            thClass: "text-uppercase align-middle",
            field: "etd",
            filterOptions: {
              enabled: false,
              placeholder: "ETD",
            },
          },
          {
            label: "ETA",
            tdClass: "align-middle text-center",

            thClass: "text-uppercase align-middle",
            field: "eta",
            filterOptions: {
              enabled: false,
              placeholder: "ETA",
            },
          },
          {
            label: "TRANSIT TIME",
            tdClass: "align-middle text-center",

            field: "transit_time",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "TRANSIT TIME",
            },
          },
          {
            label: "CARGO CUT OFF",
            tdClass: "align-middle text-center",

            field: "cargo_cut_off",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "CARGO CUT OFF",
            },
          },
          {
            label: "DOC CUT OFF",
            tdClass: "align-middle text-center",

            field: "doc_cut_off",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "DOC CUT OFF",
            },
          },
          {
            label: "TRANSIT PORT",
            tdClass: "align-middle text-center",

            field: "transit",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "TRANSIT PORT",
            },
          },
          {
            thClass: "text-uppercase align-middle",
            label: "Action",
            tdClass: "align-middle text-center",

            field: "action",
          },
        ],
        FTL: [
          {
            label: "POL",
            thClass: "text-uppercase align-middle",
            field: "pol",
            tdClass: "align-middle text-center",

            filterOptions: {
              enabled: false,
              placeholder: "POL",
            },
          },
          {
            label: "POD",
            field: "pod",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "POD",
            },
          },
          {
            label: "ETD",
            tdClass: "align-middle text-center",

            thClass: "text-uppercase align-middle",
            field: "etd",
            filterOptions: {
              enabled: false,
              placeholder: "ETD",
            },
          },
          {
            label: "ETA",
            tdClass: "align-middle text-center",

            thClass: "text-uppercase align-middle",
            field: "eta",
            filterOptions: {
              enabled: false,
              placeholder: "ETA",
            },
          },
          {
            label: "TRANSIT TIME",
            tdClass: "align-middle text-center",

            field: "transit_time",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "TRANSIT TIME",
            },
          },
          {
            label: "CARGO CUT OFF",
            tdClass: "align-middle text-center",

            field: "cargo_cut_off",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "CARGO CUT OFF",
            },
          },
          {
            label: "DOC CUT OFF",
            tdClass: "align-middle text-center",

            field: "doc_cut_off",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "DOC CUT OFF",
            },
          },
          {
            label: "TRANSIT PORT",
            tdClass: "align-middle text-center",

            field: "transit",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "TRANSIT PORT",
            },
          },
          {
            thClass: "text-uppercase align-middle",
            label: "Action",
            tdClass: "align-middle text-center",

            field: "action",
          },
        ],
        SEA_LTL: [
          {
            label: "POL",
            thClass: "text-uppercase align-middle",
            field: "pol",
            tdClass: "align-middle text-center",

            filterOptions: {
              enabled: false,
              placeholder: "POL",
            },
          },
          {
            label: "POD",
            field: "pod",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "POD",
            },
          },
          {
            label: "ETD",
            tdClass: "align-middle text-center",

            thClass: "text-uppercase align-middle",
            field: "etd",
            filterOptions: {
              enabled: false,
              placeholder: "ETD",
            },
          },
          {
            label: "ETA",
            tdClass: "align-middle text-center",

            thClass: "text-uppercase align-middle",
            field: "eta",
            filterOptions: {
              enabled: false,
              placeholder: "ETA",
            },
          },
          {
            label: "TRANSIT TIME",
            tdClass: "align-middle text-center",

            field: "transit_time",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "TRANSIT TIME",
            },
          },
          {
            label: "Vessel",
            tdClass: "align-middle text-center",

            thClass: "text-uppercase align-middle",
            field: "load_vessel",
            filterOptions: {
              enabled: false,
              placeholder: "Vessel",
            },
          },

          {
            label: "CARGO CUT OFF",
            tdClass: "align-middle text-center",

            field: "cargo_cut_off",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "CARGO CUT OFF",
            },
          },
          {
            label: "DOC CUT OFF",
            tdClass: "align-middle text-center",

            field: "doc_cut_off",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "DOC CUT OFF",
            },
          },
          {
            label: "STUFFING PLACE",
            tdClass: "align-middle text-center",

            thClass: "text-uppercase align-middle",
            field: "stuffing_place",
            width: "200px",
            filterOptions: {
              enabled: false,
              placeholder: "STUFFING PLACE",
            },
          },
          {
            thClass: "text-uppercase align-middle",
            label: "Action",
            tdClass: "align-middle text-center",

            field: "action",
          },
        ],
        LTL: [
          {
            label: "POL",
            thClass: "text-uppercase align-middle",
            field: "pol",
            tdClass: "align-middle text-center",

            filterOptions: {
              enabled: false,
              placeholder: "POL",
            },
          },
          {
            label: "POD",
            field: "pod",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "POD",
            },
          },
          {
            label: "ETD",
            tdClass: "align-middle text-center",

            thClass: "text-uppercase align-middle",
            field: "etd",
            filterOptions: {
              enabled: false,
              placeholder: "ETD",
            },
          },
          {
            label: "ETA",
            tdClass: "align-middle text-center",

            thClass: "text-uppercase align-middle",
            field: "eta",
            filterOptions: {
              enabled: false,
              placeholder: "ETA",
            },
          },
          {
            label: "TRANSIT TIME",
            tdClass: "align-middle text-center",

            field: "transit_time",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "TRANSIT TIME",
            },
          },
          {
            label: "CARGO CUT OFF",
            tdClass: "align-middle text-center",

            field: "cargo_cut_off",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "CARGO CUT OFF",
            },
          },
          {
            label: "DOC CUT OFF",
            tdClass: "align-middle text-center",

            field: "doc_cut_off",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "DOC CUT OFF",
            },
          },
          {
            label: "STUFFING PLACE",
            tdClass: "align-middle text-center",

            thClass: "text-uppercase align-middle",
            field: "stuffing_place",
            width: "200px",
            filterOptions: {
              enabled: false,
              placeholder: "STUFFING PLACE",
            },
          },
          {
            thClass: "text-uppercase align-middle",
            label: "Action",
            tdClass: "align-middle text-center",

            field: "action",
          },
        ],
        SEA_FCL: [
          {
            label: "POL",
            thClass: "text-uppercase align-middle",
            field: "pol",
            tdClass: "align-middle text-center",

            filterOptions: {
              enabled: false,
              placeholder: "POL",
            },
          },
          {
            label: "POD",
            field: "pod",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "POD",
            },
          },
          {
            label: "ETD",
            tdClass: "align-middle text-center",

            thClass: "text-uppercase align-middle",
            field: "etd",
            filterOptions: {
              enabled: false,
              placeholder: "ETD",
            },
          },
          {
            label: "ETA",
            tdClass: "align-middle text-center",

            thClass: "text-uppercase align-middle",
            field: "eta",
            filterOptions: {
              enabled: false,
              placeholder: "ETA",
            },
          },
          {
            label: "TRANSIT TIME",
            tdClass: "align-middle text-center",

            field: "transit_time",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "TRANSIT TIME",
            },
          },
          {
            label: "CARGO CUT OFF",
            tdClass: "align-middle text-center",

            field: "cargo_cut_off",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "CARGO CUT OFF",
            },
          },
          {
            label: "DOC CUT OFF",
            tdClass: "align-middle text-center",

            field: "doc_cut_off",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "DOC CUT OFF",
            },
          },
          {
            label: "TRANSIT PORT",
            tdClass: "align-middle text-center",

            field: "transit",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "TRANSIT PORT",
            },
          },
          {
            thClass: "text-uppercase align-middle",
            label: "Action",
            tdClass: "align-middle text-center",

            field: "action",
          },
        ],
      },
    };
  },
  created() {
    if (JSON.parse(localStorage.getItem("userData"))) {
      this.$router
        .replace({
          name: "schedule",
        })
        .catch((error) => {});
    }
    this.$store.dispatch("masterDataNoLogin/FETCH_ALL");
  },
  computed: {
    ...mapState("masterDataNoLogin", ["ports"]),
  },
  methods: {
    register() {
      this.$refs.registerForm.validate().then((success) => {
        if (success) {
          useJwt
            .post("userListNoLogin", {
              registerInfo: JSON.stringify({ ...this.user }),
              ...this.user,
            })
            .then((response) => {
              if (
                response.data.result == "emailExists" ||
                response.data.result == "0"
              ) {
                return this.$swal({
                  icon: "warning",
                  html: `Email already exists. If you forgot your password <a href='/auth/forgot-password'>Click here</a>`,
                  focusConfirm: false,
                  showCloseButton: true,
                  showConfirmButton: false,
                });
              }
              this.$router.replace({ name: "auth-login" });
              this.$swal({
                icon: "success",
                title: "Register success",
                text: "WR1 team is processing customer information. Please follow email or contact WR1 team directly with hotline (+84) 964 671 674!",
              });
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.message,
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });
            });
        }
      });
    },
    onUserBooking(row) {
      // console.log(row)

      this.$bvModal.show("modal-regiter");
    },
    handleOpenChange() {
      this.showTimePanel = false;
    },
    onHandlerBooking(payload) {
      // console.log('--- row ---', payload.row);
      this.valueModal = true;
      this.currentItem = payload.row;
    },
    async getSchedule() {
      var validate = await this.$refs.simpleRules.validate().then((success) => {
        return success;
      });
      if (validate) {
        this.$loading.show();
        if (this.schedule_selected == "AIR") {
          this.fields = this.fields_all.AIR;
        } else if (
          this.schedule_selected == "SEA" &&
          this.services_selected == "LCL"
        ) {
          this.fields = this.fields_all.SEA_LTL;
        } else if (
          this.schedule_selected == "SEA" &&
          this.services_selected == "FCL"
        ) {
          this.fields = this.fields_all.FCL;
        } else if (
          this.schedule_selected == "DOMESTIC" &&
          this.services_selected == "FTL"
        ) {
          this.fields = this.fields_all.FTL;
        } else if (
          this.schedule_selected == "DOMESTIC" &&
          this.services_selected == "LTL"
        ) {
          this.fields = this.fields_all.LTL;
        }

        useJwt
          .get(`scheduleListPub`, {
            params: {
              search: {
                service_type: this.constantsType[this.services_selected],
                eta: this.columnFilters.eta,
                etd: this.columnFilters.etd,
                pol: this.columnFilters.pol,
                pod: this.columnFilters.pod,
                from_date: this.columnFilters.from_date,
                to_date: this.columnFilters.to_date,
              },
              page: 1,
              pageSize: 10000000,
            },
          })
          .then((response) => {
            const data = response.data.result;
            if (!!this.userData) {
              /*this.fields.push({
                  key: "actions",
                  label: "Actions",
                  class: "text-center",
                });*/
              const mapData = data.map((obj) => {
                obj.actions = "/admin/find-a-quotation";
                return obj;
              });
              this.schedule_list = mapData;
              return;
            }
            this.schedule_list = data;
          })
          .finally(() => this.$loading.hide());
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Warning",
            text: "The field is required",
            icon: "XIcon",
            variant: "warning",
          },
        });
        return;
      }
    },
    async handSubmitModal() {
      var validate = await this.$refs.simpleRulesModal
        .validate()
        .then((success) => {
          return success;
        });
      if (validate) {
        switch (this.selected_radios) {
          case 1:
            if (
              this.userData.userType ==
                this.$Utils.CONSTANTS.USER_TYPE_O.Admin_Sale ||
              this.userData.userType == this.$Utils.CONSTANTS.USER_TYPE_O.Admin
            ) {
              this.$router.push("/admin/my-quotation");
            } else {
              this.$router.push("/user/my-quotation");
            }
            break;
          default:
            if (
              this.userData.userType ==
                this.$Utils.CONSTANTS.USER_TYPE_O.Admin_Sale ||
              this.userData.userType == this.$Utils.CONSTANTS.USER_TYPE_O.Admin
            ) {
              this.$router.push("/admin/my-quotation");
            } else {
              this.$router.push("/user/my-quotation");
            }
            break;
        }
      }
    },
  },
  mounted() {},
  watch: {
    schedule_selected() {
      // useJwt
      //   .get(`prepare-check-schedule?type=${this.schedule_selected}`, {})
      //   .then((response) => {
      //     const dataPolList = response.data.result.polList;
      //     const dataPodList = response.data.result.podList;
      //     const mapPolList = dataPolList.map((obj) => {
      //       obj.text = obj.text || obj.portName;
      //       obj.id = obj.id || obj.portCode;
      //       return obj;
      //     });
      //     const mapPodList = dataPodList.map((obj) => {
      //       obj.text = obj.text || obj.portName;
      //       obj.id = obj.id || obj.portCode;
      //       return obj;
      //     });
      //     this.polList = mapPolList;
      //     this.podList = mapPodList;
      //   });

      if (this.schedule_selected) this.services = [];
      this.services.push(...this.services_options[this.schedule_selected]);

      this.schedule_selected == "AIR" ? (this.services_selected = "AIR") : "";
    },
  },
};
</script>
  <style>
.select2-selection--single {
  border: 1px solid #2b938c;
  border-radius: 1.5rem;
}

.select2-selection--single:before {
  content: "";
  position: absolute;
  right: 14px;
  top: 0;
  bottom: 0;
  width: 14px;
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDFMNSA1TDkgMSIgc3Ryb2tlPSIjMkI5MzhDIiBzdHJva2Utd2lkdGg9IjEuMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=")
    center / contain no-repeat;
}

.select2-selection__arrow {
  background: none;
  display: none !important;
}

@media (max-width: 865px) {
  .table-responsive-sm {
    overflow: hidden;
    overflow-x: scroll;
  }

  .card {
    overflow: hidden;
  }
}

.has-error .select2-selection {
  border-color: red !important;
}

.schedule .vue-dropzone > .dz-preview .dz-details {
  background: #2b938c;
}

.schedule .dropzone {
  border: 1px solid #2b938c;
  border-radius: 1.5rem;
}

.schedule .select2-selection--single {
  border: 1px solid #2b938c;
}

.schedule .select2-selection--single:before {
  content: "";
  position: absolute;
  right: 14px;
  top: 0;
  bottom: 0;
  width: 14px;
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDFMNSA1TDkgMSIgc3Ryb2tlPSIjMkI5MzhDIiBzdHJva2Utd2lkdGg9IjEuMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=")
    center / contain no-repeat;
}

.schedule .select2-selection__arrow {
  background: none;
  display: none !important;
}

.vgt-table td,
.vgt-table th {
  vertical-align: middle !important;
  font-size: 1rem;
}

.vgt-table th {
  text-align: center;
}
</style>
  <style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.border-dr-top {
  border-top: 1px solid #e6e6e6;
}
</style>
  